<script setup lang="ts">
import { Button, FieldInput } from '@proj-airi/ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  providerName: string
  placeholder?: string
  required?: boolean
  label?: string
  description?: string
}>()

const { t } = useI18n()

const modelValue = defineModel<string>({ required: false, default: '' })

const computedDescription = computed(() => {
  return props.description || `API Key for ${props.providerName}`
})
</script>

<template>
  <div class="flex items-end gap-2">
    <FieldInput
      v-model="modelValue"
      :label="label || t('settings.pages.providers.common.fields.field.api-key.label')"
      :description="computedDescription"
      :placeholder="placeholder"
      :required="required"
      type="password"
      class="flex-1"
    />
    <Button
      v-if="modelValue"
      variant="ghost"
      size="sm"
      icon="i-ph:trash"
      :title="t('settings.common.reset')"
      @click="modelValue = ''"
      class="mb-0.5"
    />
  </div>
</template>
